import React from 'react'
import SectionLabel from '../SectionLabel/SectionLabel'
import Styles from '../Content/Content.css'
import Button from '../Button/Button'

const Need = () => {
  return (
    <section className="pt-10 pb-10 md:pt-20 md:pb-20 bg-color-arizona-blue text-white need-container">
      <div className="container">
        <SectionLabel
          heading={'What You Need To Do'}
          body={'Think you have what it takes to go honors? So do we.'}
          styles={'text-white'}
        />
        <div className="pt-4">
          <div>
            <div>
              <ol className="list pl-1">
                <li>1. Start by submitting your University of Arizona application.</li>
                <li>2. Visit the “Supplemental Application” tab in your application portal. </li>
                <li>
                  3. Complete the honors application, which includes additional questions and a
                  recommendation component
                </li>
              </ol>
            </div>

            <div className="need-button-wrap pt-4 flex max-md:justify-center">
              <Button
                linkId=""
                className="border-white"
                link="https://slate.admissions.arizona.edu/apply/?_gl=1*1g3vdo9*_ga*Mzc1NjE3MjA4LjE2OTU0MDk1NTA.*_ga_7PV3540XS3*MTcxMjg2NDY4Ny4zNTQuMS4xNzEyODY1MjE4LjYwLjAuMA.."
              >
                Start An Application
              </Button>
            </div>
            <div className="pt-4">
              <p>
                Want to learn more about the Franke Honors College and everything it offers? Learn
                about our{' '}
                <a
                  className="blue-link"
                  href="https://frankehonors.arizona.edu/admissions/visit-us"
                  target="_blank"
                >
                  visit opportunities.
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Need
